import { Observable } from 'rxjs';
import { CanDeactivateFn } from '@angular/router';

export interface CanComponentDeactivate {
  /** Settles pending work (e.g. flushes a save) and answers `false` only when leaving would lose something. */
  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean;
}

// The page decides; the guard neither prompts nor discards.
export const unsavedChangesGuard: CanDeactivateFn<CanComponentDeactivate> = (component) =>
  component?.canDeactivate ? component.canDeactivate() : true;
